import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all hover:border-accent-300"
      data-product-shop=""
    >
      <div className="aspect-[3/4] overflow-hidden bg-background-100 relative">
        <img
          src={comic.cover}
          alt={`${comic.title} - 漫画皮在线漫画`}
          title={`${comic.title} - 免费在线阅读`}
          loading="lazy"
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-secondary-500 text-background-50 rounded-full whitespace-nowrap">
            完结
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-400 text-[10px]"></i>
            <span>{comic.rating}</span>
            <span className="ml-auto flex items-center gap-1">
              <i className="ri-eye-line text-[10px]"></i>
              {(comic.hotness / 10000).toFixed(0)}万
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 mb-1.5 line-clamp-1 group-hover:text-accent-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mb-1 whitespace-nowrap">{comic.author}</p>
        <div className="flex items-center gap-2">
          {comic.category.slice(0, 2).map((cat) => (
            <span key={cat} className="px-1.5 py-0.5 text-[10px] bg-background-100 text-foreground-600 rounded whitespace-nowrap">
              {cat}
            </span>
          ))}
          <span className="ml-auto text-[10px] text-foreground-400 whitespace-nowrap">
            至{comic.latestChapter}话
          </span>
        </div>
      </div>
    </Link>
  );
}